// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"413c55d5","726":"f458fb75"}[chunkId] + ".chunk.js";
};